<div class="mojo-admin-page panel data-table doc-centre-no-pad">
  <p-table [value]="categories | async"
           selectionMode="single"
           responsiveLayout="scroll"
            [(selection)]="selectedCategory" dataKey="key.Uri">
    <ng-template pTemplate="header">
      <tr>
        <th>Category</th>
        <th>Default Expiry</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-category>
      <tr [pSelectableRow]="category">
        <td>{{category.name}}</td>
        <td>{{getExpiryLabel(category)}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div class="sys-settings-action-buttons">
  <button id="add-button" type="button" pButton (click)="showAddDialog()" label="Add"></button>
  <button id="edit-button" type="button" [disabled]="isNoneSelected()" pButton (click)="showEditDialog()" label="Edit"></button>
  <button id="delete-button" type="button" [disabled]="isNoneSelected()" pButton (click)="confirmDelete()" label="Delete"></button>
</div>

<mojo-pma-document-centre-category-dialog [expiryTypes]="defaultExpiryTypes"
                                          [existingCategories]="categories | async"
                                          (onSave)="handleOnSave($event)">
</mojo-pma-document-centre-category-dialog>
